import { render, staticRenderFns } from "./ParticipacaoCustoTotalAbsoluto.vue?vue&type=template&id=67dbbd7c&scoped=true&"
import script from "./ParticipacaoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dbbd7c",
  null
  
)

export default component.exports